module.exports = __webpack_public_path__ + "static/media/logo-uvmk.7b8b35e5.png";